<div class="kr-loading-animation" :class="dynamicClasses.wrapper"><i class="kr-loader" :class="dynamicClasses.loader"></i></div>